module.exports = __webpack_public_path__ + "img/11087943_L.034dc73e.png";